<div class="bundle-service-card rounded-medium flex flex--nowrap">
  <fcom-icon class="icon-medium flex--shrink0 nordic-blue-900-text" [name]="icon" />
  <div class="ps-xsmall-l flex flex--column flex-1">
    <div class="flex flex--space-between">
      <span class="font-body-1 bold-type">{{ title }}</span>
      <!--
        Always rendered (never *ngIf'd out): the tag's width is reserved in the layout even when
        hidden, so the title's available width — and therefore how many lines it wraps to — doesn't
        change when the in-cart state toggles, which would otherwise change the row's height.
      -->
      <fcom-tag
        class="flex--self-start ms-xsmall-l"
        [style.visibility]="inCart || isTierBenefit ? 'visible' : 'hidden'"
        [theme]="isTierBenefit ? TagTheme.DEFAULT : TagTheme.SUCCESS"
        [attr.data-testid]="'bundle-service-card-in-cart-' + category"
      >
        @if (isTierBenefit) {
          <fcom-icon [name]="SvgLibraryIcon.FINNAIR_PLUS" class="icon-medium ms-xxsmall-r" />
          <span class="regular-type">{{ 'ancillaries.bundle.serviceCard.tierBenefitTag' | finLocalization }}</span>
        } @else {
          {{ 'ancillaries.bundle.serviceCard.inCartTag' | finLocalization }}
        }
      </fcom-tag>
    </div>
    <span class="font-body-2 ms-xxsmall-t" [innerHTML]="description"></span>
    @if (hasModal) {
      <fcom-link
        class="font-body-2 ms-xxsmall-t"
        [attr.data-testid]="'ancillary-bundle-details-' + category"
        (afterNavigation)="modalOpen = true"
        >{{ detailsLinkKey | finLocalization }}</fcom-link
      >
    }
  </div>
</div>

@if (hasModal) {
  <fin-product-info-modal [open]="modalOpen" [serviceInfo]="service" (closeModal)="modalOpen = false" />
}
